import { Tabs, Tab } from '@material-ui/core'
import { red } from '@material-ui/core/colors'
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles'
import { TFunction } from 'i18next'
import { FC } from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { navigate } from '../../../actions/routes'
import { selectApartmentStatusFromPathname } from '../../../selectors/router'
import { StateInterface } from '../../../types/states'

const statuses = [
  'created',
  'confirmed',
  'marketing',
  'followUp',
  'rentContractWanted',
  'rented',
  'cancelled',
  'all'
]

interface PropsFromState {
  status: string
}

interface DispatchProps {
  doNavigation: (path: string) => void
}

const mapStateToProps = (state: StateInterface) => {
  const status = selectApartmentStatusFromPathname(state)
  return {
    status
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  doNavigation: (path: string) => dispatch(navigate(path))
})

interface OwnProps {
  // status: string
  t: TFunction
}

type NavProps = OwnProps & DispatchProps & PropsFromState
const theme = createTheme({
  overrides: {
    MuiTabs: {
      indicator: {
        backgroundColor: red[700]
      }
    },
    MuiTab: {
      root: {
        fontFamily: 'CircularRegular'
      }
    }
  }
})
const NavApartmentStatuses: FC<NavProps> = ({ status, t, doNavigation }) => (
  <MuiThemeProvider theme={theme}>
    <Tabs
      value={status || 'all'}
      onChange={(event, newValue) => {
        doNavigation(
          '/adminApartments' + (newValue === 'all' ? '' : '/' + newValue)
        )
      }}
    >
      {statuses.map((_status) => (
        <Tab
          style={{ fontWeight: 400 }}
          key={_status}
          label={t(`adminApartments.statuses.${_status}`)}
          value={_status}
        />
      ))}
    </Tabs>
  </MuiThemeProvider>
)

export default connect<PropsFromState, DispatchProps, OwnProps, StateInterface>(
  mapStateToProps,
  mapDispatchToProps
)(NavApartmentStatuses)
